export default {
      id: "search-usage",
      viewBox: "0 0 22 22",
      url: __webpack_public_path__ + "sprite-46b249.svg#search-usage",
      toString: function () {
        return this.url;
      }
    }